const pleseUpgrade = () => import(/* webpackChunkName:"chunk-pleseUpgrade" */ '../views/P4_Page/Deprecated/index.vue')
const actEnded = () => import(/* webpackChunkName:"chunk-pleseUpgrade" */ '../views/P4_Page/Deprecated/ended.vue')

// prettier-ignore
const routes = [
  {
    path: '/invite-performance', name: 'invite-performance', component: pleseUpgrade
  },
  {
    path: '/intimate-diary', name: 'intimate-diary', component: pleseUpgrade
  },
  {
    path: '/intimate', name: 'intimate', component: pleseUpgrade
  },
  {
    path: '/intimate-rule', name: 'intimate-rule', component: pleseUpgrade
  },
  {
    path: '/invite/boys', name: 'invite-boys', component: pleseUpgrade
  },
  {
    path: '/invite/boys/download', name: 'invite-boys-download', component: pleseUpgrade
  },
  {
    path: '/invite-hostess', name: 'invite-hostess', component: pleseUpgrade
  },
  {
    path: '/invite-hostess-rules', name: 'invite-hostess-rules', component: pleseUpgrade
  },
  {
    path: '/acquisition', name: 'acquisition', component: pleseUpgrade
  },
  // 圣诞
  {
    path: '/christmas-main-male', name: 'christmas-main-male', component: actEnded
  },
  {
    path: '/christmas-rank-male', name: 'christmas-rank-male', component: actEnded
  },
  {
    path: '/christmas-rules-male', name: 'christmas-rules-male', component: actEnded
  },
  {
    path: '/christmas-main-female', name: 'christmas-main-female', component: actEnded
  },
  {
    path: '/christmas-rank-female', name: 'christmas-rank-female', component: actEnded
  },
  {
    path: '/christmas-rules-female', name: 'christmas-rules-female', component: actEnded
  },
  // 万圣节
  {
    path: '/halloween2025-main-male', name: 'holiday-main-male', component: actEnded
  },
  {
    path: '/halloween2025-rank-male', name: 'halloween2025-rank-male', component: actEnded
  },
  {
    path: '/halloween2025-rules-male', name: 'halloween2025-rules-male', component: actEnded
  },
  {
    path: '/halloween2025-main-female', name: 'halloween2025-main-female', component: actEnded
  },
  {
    path: '/halloween2025-rank-female', name: 'halloween2025-rank-female', component: actEnded
  },
  {
    path: '/halloween2025-rules-female', name: 'halloween2025-rules-female', component: actEnded
  },
  // 元旦
  {
    path: '/newyearsday-main-male', name: 'newyearsday-main-male', component: actEnded
  },
  {
    path: '/newyearsday-rank-male', name: 'newyearsday-rank-male', component: actEnded
  },
  {
    path: '/newyearsday-rules-male', name: 'newyearsday-rules-male', component: actEnded
  },
  {
    path: '/newyearsday-main-female', name: 'newyearsday-main-female', component: actEnded
  },
  {
    path: '/newyearsday-rank-female', name: 'newyearsday-rank-female', component: actEnded
  },
  {
    path: '/newyearsday-rules-female', name: 'newyearsday-rules-female', component: actEnded
  },
  // 情人节-2026
  {
    path: '/valentine-main-male', name: 'valentine-main-male', component: actEnded
  },
  {
    path: '/valentine-rank-male', name: 'valentine-rank-male', component: actEnded
  },
  {
    path: '/valentine-rules-male', name: 'valentine-rules-male', component: actEnded
  },
  {
    path: '/valentine-main-female', name: 'valentine-main-female', component: actEnded
  },
  {
    path: '/valentine-rank-female', name: 'valentine-rank-female', component: actEnded
  },
  {
    path: '/valentine-rules-female', name: 'valentine-rules-female', component: actEnded
  }
]

export default routes
